import { WW } from '_utils';

export const buttonHeight = WW * 0.95 * 0.2;
export const buttonWidth = WW / 5;
export const svgHeight = 100;
export const offsetFromTop = 120;
export const tabbarNegativeMargin = 40;
